import React, { useEffect, useState } from "react";
import { FaInfoCircle } from "react-icons/fa";
import "../WarningUploadImage/WarningUploadImage.css";

const WarningUploadImage = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    setIsModalVisible(true);
  }, []);

  const rules = [
    {
      title: "1. No Fake Photos:",
      description:
        "Upload your own picture. Not your friend, not a celebrity, not a group photo.",
    },
    {
      title: "2. Show Your Face:",
      description:
        "No backs, no hiding, no filters that make you unrecognizable.",
    },
    {
      title: "3. No Nudity:",
      description: "No Pornographic or provocative pictures.",
    },
    {
      title: "4. Non-Human Photos:",
      description:
        "No pets, houses, random screenshots, products, or anything that isn't a human being.",
    },
    {
      title: "5. Low-Quality Images:",
      description: "Blurry, pixelated, or over-edited pictures won't cut it.",
    },
  ];

  if (!isModalVisible) return null;

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <div className="info-icon">
          <FaInfoCircle size={24} color="#e60044" />
        </div>
        <h2 className="modal-title">
          Before You Upload Your Photos,
          <br />
          Please Read Carefully
        </h2>
        <p className="warning-text">
          Break these rules, and you will be banned, very fast and permanently.
          No second chances.
        </p>
        <div className="rules-list">
          {rules.map((rule, idx) => (
            <div key={idx} className="rule-box">
              <strong className="rule-title">{rule.title}</strong>
              <p className="rule-description">{rule.description}</p>
            </div>
          ))}
        </div>
        <button
          className="close-button"
          onClick={() => setIsModalVisible(false)}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default WarningUploadImage;
